import { useEffect, useState } from "react";

import { fetchImageBlob } from "../../../../services/utils";

const useAuthenticatedImageSrc = (src) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (!src) {
      setImageSrc(null);
      return;
    }

    if (src.startsWith("blob:")) {
      setImageSrc(src);
      return;
    }

    let cancelled = false;
    let blobUrl = null;

    fetchImageBlob(src)
      .then((blob) => {
        if (cancelled) return;
        blobUrl = URL.createObjectURL(blob);
        setImageSrc(blobUrl);
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("useAuthenticatedImageSrc: failed to load image", err);
          setImageSrc(null);
        }
      });

    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [src]);

  return imageSrc;
};

export { useAuthenticatedImageSrc };
